export default "__VITE_ASSET__BNGZRjVB__"